import { setupSteps, type Setup } from "../api/sources";
import { destinationOf } from "./routes";

/**
 * Whether this workspace is still setting up for its first investigation: its setup
 * has been read, and a step of it is not done. The trail and each page's "continue"
 * step belong to that first run alone (#805); unread, a page does not guess.
 */
export function inFirstRun(setup: Setup | null): boolean {
  return setup !== null && !setupSteps(setup).every((step) => step.done);
}

/** Navigation through setup; position is not a claim that earlier steps succeeded. */
export function SetupTrail({ current, setup }: { current: "accounts" | "sources" | "provider"; setup: Setup | null }) {
  if (!inFirstRun(setup)) return null;
  return (
    <nav aria-label="First investigation setup" className="setup-trail">
      <ol>
        {[
          { id: "accounts", label: "AWS account", href: destinationOf("accounts").path },
          { id: "sources", label: "Alert source", href: destinationOf("sources").path },
          { id: "provider", label: "Model provider", href: destinationOf("provider").path },
        ].map((step, index) => (
          <li key={step.id}>
            <a href={step.href} aria-current={current === step.id ? "step" : undefined}>
              <span aria-hidden="true">{index + 1}</span>{step.label}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}
